// Fire WEDCS click events automatically on anchor, image, area and input clicks
( function( $ ) {

	var getAnchorEventDefaults = function( el ) {
		/*
            Click Name: anchor.textContent
            Click target: anchor.href
            Click Id: anchor.id,
            Event Type: 1
        */

		// check if link is an image link
		if ( el.hasChildNodes() ) {
			var children = el.childNodes;

			for ( var i = 0; i < children.length; i++ ) {
				// if a child is an image, send the image link bi event
				if ( children[i].nodeName.toLowerCase() === 'img' ) {
					return getAnchorImgEventDefaults( el, children[i] );
				}
			}
		}

		return {
			'wcs.cn': el.textContent,
			'wcs.ct': el.href,
			'wcs.cid': el.id,
			'wcs.cot': 1
		};
	};

	var getAnchorImgEventDefaults = function( a, img ) {
		/*
            Click Name: image.alt
            Click target: anchor.href
            Click Id: anchor.id(1), image.id(2)
            Event Type: 2
        */

		// fallback to an id on an img, if no id on anchor is set
		var cid  = ( a.id == '' ) ? img.id : a.id;
		return {
			'wcs.cn': img.alt,
			'wcs.ct': a.href,
			'wcs.cid': cid,
			'wcs.cot': 2
		};
	};

	var getInputEventDefaults = function( input ) {
		/*
            Click Name: input.value(1), input.name(2)
            Click target: form.action(1), window.location.pathname(2)
            Click Id: input.id
            Event Type: 4
        */

		// get parent form
		var form = $( input ).closest( 'form' )[0];
		// fallback to window.location.pathname if no form or form action is set
		var ct = ( typeof form !== 'undefined' && form.action ) ? form.action : window.location.pathname;
		// TO_DISCUSS: if value is blank on first click, but filled in on second, different values will be passed for same element
		var cn = ( input.value ) ? input.value : input.name;
		return {
			'wcs.cn': cn,
			'wcs.ct': ct,
			'wcs.cid': input.id,
			'wcs.cot': 4
		};
	};

	var getCustomEventAttribute = function( el, attr ) {
		var $attr_el = $( el ).closest( '['+attr.replace( '.', '\\.' )+']' ),
			attr_val = $attr_el.attr( attr );
		return ( $attr_el && attr_val ) ? attr_val : '';
	};

	var getCustomEventTitle = function( el ) {
		var mstitle = $.trim( getCustomEventAttribute( el, 'ms.title' ) );
		// If element is undefined, abort.
		if ( undefined === el ) {
			return mstitle;
		}

		// if the above method returns a blank string or nothing
		// set a title based on a child image alt attribute
		if ( !mstitle ) {
			//console.log(el);
			var imgs = el.getElementsByTagName( 'img' );
			mstitle = ( imgs.length ) ? imgs[0].alt : mstitle;
		}
		// if still blank, set a title based on the text content
		return ( mstitle ) ? mstitle : $.trim( el.textContent );
	};

	var getCustomEventValues = function( el, arr ) {
		var obj = {};

		for ( var i = 0; i < arr.length; i++ ) {
			var key = arr[i],
				val;

			if ( arr[i] === 'ms.title' ) {
				val = getCustomEventTitle( el );
			} else {
				val = getCustomEventAttribute( el, arr[i] );
			}

			if ( val ) { obj[key] = val; }
		}

		return obj;
	};

	var sendMscomCustomEvent = function( opts ) {
		var arr = [];
		// format opts into an array of parameters the custom event function can handle
		for ( var key in opts ) {
			if ( opts.hasOwnProperty( key ) ) {
				var k = key.toString();
				arr.push( k );
				arr.push( opts[key] );
			}
		}
		if ( typeof MscomCustomEvent !== 'undefined' && !window.mochaTest ) {
			MscomCustomEvent.apply( null, arr );
		}
	};

	var matchAgainst = function( el, list ) {
		// check if element matches the list
		var $el = $( el );
		for ( var i = 0; i < list.length; i++ ) {
			if ( $el.is( list[i] ) ) {
				return true;
			}
		}
		return false;
	};

	var forceArrayFormat = function( x ) {
		// if its null or some sort of falsey
		if ( !x ) {
			return [];
		}
		// if its of type string
		if ( typeof x === 'string' ) {
			// split string into an array
			var arr = x.split( ',' ),
				trim_arr = [];

			for ( var i = 0; i < arr.length; i++ ) {
				trim_arr.push( $.trim( arr[i] ) );
			}

			return trim_arr;
		}
		// if its an array already, return the array
		if ( x.constructor === Array ) {
			return x;
		}

		// if its anything else, ignore it and return an empty array
		return [];
	};

	var wedecsClickTracking = function( settings ) {
		var self = this;

		var anchorEnabled,
			inputEnabled,
			globalDeniedList;

		this.msAttributes = [
			'data-bi-aN',
			'data-bi-name',
			'ms.title',
			'data-bi-slot'
		];

		this.config = {
			// blacklist options
			a: [],
			input: [],
			all: ['.custom-bi-event']
		};

		$.extend( this.config, settings );
		// check if the a or input options are set to false instead of empty arrays
		anchorEnabled = ( !this.config.a ) ? false : true;
		inputEnabled = ( !this.config.input ) ? false : true;

		// make sure any lists are actual arrays, not comma delimited strings
		this.config.all = forceArrayFormat( this.config.all );
		this.config.a = forceArrayFormat( this.config.a );
		this.config.input = forceArrayFormat( this.config.input );

		// make a working copy of the denied list
		globalDeniedList = this.config.all.slice();

		// check if the default '<a>' or '<input>' tag clicks are listed to be disabled
		// if they are, set boolean flags and remove them from the denied list to prevent redundancy
		for ( var i = 0; i < globalDeniedList.length; i++ ) {
			if ( globalDeniedList[i] === 'a' ) {
				anchorEnabled = false;
				globalDeniedList.splice( i, 1 );
			}
			if ( globalDeniedList[i] === 'input' ) {
				inputEnabled = false;
				globalDeniedList.splice( i, 1 );
			}
		}

		// set anchor click events if enabled
		if ( anchorEnabled ) {

			var onAnchorClick = function( e ) {
				var deniedList = globalDeniedList.concat( self.config.a );

				// if element is allowed, send BI event.
				if ( !matchAgainst( this, deniedList ) ) {

					// get the anchor default tags
					var obj = getAnchorEventDefaults( this );
					// add in any custom tags
					$.extend( obj, getCustomEventValues( this, self.msAttributes ) );
					// send the link bi event
					sendMscomCustomEvent( obj );
				}

			};

			$( 'body' ).on( 'mousedown', 'a', onAnchorClick );

		}


		// set input click events if enabled
		if ( inputEnabled ) {

			var onInputClick = function( e ){
				var deniedList = globalDeniedList.concat( self.config.input );

				// if element is allowed, send BI event.
				if ( !matchAgainst( this, deniedList ) ) {
					// get the anchor default tags
					var obj = getInputEventDefaults( this );
					// add in any custom tags
					$.extend( obj, getCustomEventValues( this, self.msAttributes ) );
					// send the input bi event
					sendMscomCustomEvent( obj );
				}
			};

			$( 'body' ).on( 'mousedown', 'input', onInputClick );

		}

	};

	wedecsClickTracking.prototype.sendCustomEvent = function( el, obj ){
		// ensure element passed is not a list of elements
		var el = ( typeof el.length !== 'undefined' ) ? el[0] : el;

		var merged_obj = {};

		$.extend( merged_obj, getCustomEventValues( el, this.msAttributes ), obj );

		sendMscomCustomEvent( merged_obj );

		return merged_obj;
	};

	// test harness check
	if ( typeof window.mochaTest !== 'undefined' && window.mochaTest === true ) {
		$.extend( wedecsClickTracking.prototype, {
			'_matchAgainst': matchAgainst,
			'_forceArrayFormat': forceArrayFormat,
			'_getCustomEventTitle': getCustomEventTitle,
			'_getCustomEventValues': getCustomEventValues,
			'_getAnchorEventDefaults': getAnchorEventDefaults,
			'_getAnchorImgEventDefaults': getAnchorImgEventDefaults,
			'_getInputEventDefaults': getInputEventDefaults
		} );
	}

	//expose object to the global scope

	if ( typeof window.MS !== 'object' ) {
		window.MS = {};
	}

	window.MS.wedecs = wedecsClickTracking;

} )( window.jQuery );
